import { postData } from "../services/global.service";
import { APIEnv, APIStatus } from "../interface/baseInterfaces";
import { SEO_MAPPING } from "../constants/constants";
import { API_CONSTANTS } from "../constants/search.constanst";

export class SeoHandlerClass {
  url: string = "";

  constructor(url: string) {
    this.url = url;
  }

  getSeoDetails = async (pathName: string) => {
    let params: any = {};
    let API_VALUE: any = "";

    if (
      pathName == SEO_MAPPING.LANDING_PAGE.URL_CONTAINS
    ) {
      params =  SEO_MAPPING.LANDING_PAGE.PARAMS;
      API_VALUE = SEO_MAPPING.LANDING_PAGE.API_VALUE;
    } else if (
      pathName == SEO_MAPPING.HOME_PAGE.URL_CONTAINS
    ) {
      params =SEO_MAPPING.HOME_PAGE.PARAMS
      API_VALUE = SEO_MAPPING.HOME_PAGE.API_VALUE;
    } else {
      return null;
    }

    return await postData(
      API_CONSTANTS.SEO_DETAILS,
      {
        API_VALUE: API_VALUE,
        params: params,
      },
      APIEnv.NODE_PREMIUM,
      "post"
    )
      .then((response) => {
        if (response?.ResponseType === APIStatus.SUCCESS) {
          return response?.data?.data;
        }
      })
      .catch((err) => {
        console.log(err);
        return null;
      });
  };
}
